import React from "react";

function IllustrationGrowTogether() {
  return (
    <svg
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      //   xmlns:xlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 1023.46 837.84"
    >
      <defs>
        <linearGradient
          id="a"
          x1="352.43"
          y1="317.15"
          x2="352.43"
          y2="135.71"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="gray" stop-opacity=".25" />
          <stop offset=".54" stop-color="gray" stop-opacity=".12" />
          <stop offset="1" stop-color="gray" stop-opacity=".1" />
        </linearGradient>
        <linearGradient
          id="b"
          x1="569.83"
          y1="551.49"
          x2="569.83"
          y2="380.82"
          /* xlink: */ href="#a"
        />
        <linearGradient
          id="c"
          x1="171.5"
          y1="319.2"
          x2="171.5"
          y2="319.02"
          /* xlink: */ href="#a"
        />
        <linearGradient
          id="d"
          x1="228.01"
          y1="853.75"
          x2="228.01"
          y2="250.26"
          /* xlink: */ href="#a"
        />
        <linearGradient
          id="e"
          x1="944.05"
          y1="849.94"
          x2="944.05"
          y2="268.42"
          /* xlink: */ href="#a"
        />
      </defs>
      <ellipse
        cx="176"
        cy="807.85"
        rx="176"
        ry="29.99"
        fill="#00c7fa"
        opacity=".1"
      />
      <ellipse
        cx="847.47"
        cy="800.75"
        rx="176"
        ry="29.99"
        fill="#00c7fa"
        opacity=".1"
      />
      <path
        d="M274.41.46c-46 2.46-92.48 15.9-128.37 44.79-31.49 25.36-54.2 65.23-48.66 105.29 6.54 47.29 48.73 81.69 64.38 126.8 10.07 29 8.5 61 1.91 91-4.24 19.33-10.76 38.68-23.29 54-22.57 27.56-63.3 40.86-74.39 74.71-12.06 36.81 18.33 72.91 46.88 99.09 22.79 20.89 46.66 41.68 75.38 53.13 21 8.38 43.79 11.39 66.38 12.59a442.71 442.71 0 0 0 183-29.24c27.91-10.83 54.91-24.56 84.12-31.09 62.25-13.92 126.3 6.15 189.39 15.55a566.44 566.44 0 0 0 163.17.48c34.06-4.86 69.25-13.63 94.9-36.55 26-23.27 39-59.29 37.56-94.19s-16.16-68.5-37.84-95.9c-28-35.39-66.62-60.57-100.22-90.73a433.34 433.34 0 0 1-86.22-106.58c-13.2-23-24.43-47.41-41.53-67.66-26.67-31.56-65.35-50.33-104-64.83-89.16-33.4-181.64-40.2-274.6-54.96-29.05-4.63-58.52-7.24-87.95-5.7z"
        fill="#00c7fa"
        opacity=".1"
      />
      <g opacity=".7">
        <path fill="#f6f7f9" d="M258.54 367.11H449.5v106.71H258.54z" />
        <circle cx="294.49" cy="414.48" r="19.88" fill="#00c7fa" opacity=".2" />
        <path
          fill="#00c7fa"
          d="M338.61 390.92h86.62v5.45h-86.62zM338.61 404.81h44.13v5.45h-44.13zM338.61 418.7h71.37v5.45h-71.37zM338.61 432.59h86.62v5.45h-86.62zM401.27 452.64h23.97v10.53h-23.97z"
          opacity=".2"
        />
        <path fill="#f6f7f9" d="M419.31 72.2h190.96v106.71H419.31z" />
        <circle cx="455.27" cy="119.57" r="19.88" fill="#00c7fa" opacity=".2" />
        <path
          fill="#00c7fa"
          d="M499.39 96.01h86.62v5.45h-86.62zM499.39 109.9h44.13v5.45h-44.13zM499.39 123.79h71.37v5.45h-71.37zM499.39 137.69h86.62v5.45h-86.62zM562.04 157.73h23.97v10.53h-23.97z"
          opacity=".2"
        />
        <path fill="#f6f7f9" d="M482.87 251.36h190.96v106.71H482.87z" />
        <circle cx="518.82" cy="298.74" r="19.88" fill="#00c7fa" opacity=".2" />
        <path
          fill="#00c7fa"
          d="M562.95 275.18h86.62v5.45h-86.62zM562.95 289.07h44.13v5.45h-44.13zM562.95 302.96h71.37v5.45h-71.37zM562.95 316.85h86.62v5.45h-86.62zM625.6 336.9h23.97v10.53H625.6z"
          opacity=".2"
        />
      </g>
      <path fill="url(#a)" d="M191.88 135.71h321.11v181.44H191.88z" />
      <path fill="#f6f7f9" d="M194.15 137.96h316.6v176.93h-316.6z" />
      <circle cx="253.75" cy="216.51" r="32.96" fill="#00c7fa" opacity=".2" />
      <path
        fill="#00c7fa"
        d="M326.92 177.44h143.62v9.03H326.92zM326.92 200.48h73.16v9.03h-73.16zM326.92 223.51h118.33v9.03H326.92zM326.92 246.54h143.62v9.03H326.92z"
        opacity=".2"
      />
      <path fill="#00c7fa" d="M430.79 279.78h39.74v17.46h-39.74z" />
      <path fill="url(#b)" d="M417.12 380.82h305.42v170.67H417.12z" />
      <path fill="#f6f7f9" d="M419.23 381.99h301.2v168.32h-301.2z" />
      <circle cx="475.94" cy="456.72" r="31.36" fill="#00c7fa" opacity=".2" />
      <path
        fill="#00c7fa"
        d="M545.54 419.55h136.63v8.59H545.54zM545.54 441.47h69.6v8.59h-69.6zM545.54 463.38h112.57v8.59H545.54zM545.54 485.29h136.63v8.59H545.54z"
        opacity=".2"
      />
      <path
        fill="#00c7fa"
        d="M644.36 516.91h37.81v16.61h-37.81z"
        opacity=".5"
      />
      <path
        d="M171.13 319l.74.16a1 1 0 0 0-.74-.16z"
        transform="translate(-88.27 -31.08)"
        fill="url(#c)"
        opacity=".1"
      />
      <path
        d="M325.85 435.17c-2.21-14.84-15.69-49.46-15.69-49.46-.24-1-.5-2.06-.8-3.08-9.57-32.89-22.81-35.8-22.81-35.8l-47.43-10.11a3.54 3.54 0 0 1 1 .94l-.75.12a18.57 18.57 0 0 1-4.16-9c-.09-.49-.17-1-.23-1.52a33.35 33.35 0 0 0-2.72-50.16c-.49-.39-1-.76-1.52-1.13 2.24-2.37 2.31-5.68.64-9-3.74-7.77-11.86-12.68-20.22-15.07-6.38-1.83-13.3-2.42-19.62-.42-3.61 1.14-6.89 3.07-10.27 4.76-6.3 3.15-13.24 5.64-18 10.81-1.11 1.21-2.12 2.75-1.8 4.34.25 1.19 1.18 2.1 1.79 3.16 1.35 2.36 1 5.33.09 7.9s-2.29 5-2.94 7.6-.39 5.74 1.59 7.62a34.37 34.37 0 0 0 3 2.1 15.27 15.27 0 0 1 2.83 3.17l5.62 7.59a77.57 77.57 0 0 1 7 10.69c1.39 2.75 2.48 5.7 4.35 8.16a12.82 12.82 0 0 0 1.87 2c-.18-.07-.37-.13-.55-.21a8.51 8.51 0 0 0 6.28 2.41h.28a1.71 1.71 0 0 0 1.15-.47v1c.1 3.65.09 7.53-.17 11.17l-.44-.22a3.81 3.81 0 0 0-4.09.43l-43.69 35s-9.49 13-8.17 35.4l-7.65 33.62s-9.57 28.53-2.21 48.9 11.63 32 11.63 32 2.94 23.14 7.36 25 6.33 2.92 6.33 2.92l.88 5.53s.29.53.81 1.45c3.22 5.59 15.13 25.33 22.06 23.23a89.83 89.83 0 0 1 1.13 16.21l6.84 46s4.78 12.51 4.49 19.06 5.59 15.87 5.59 15.87a30.34 30.34 0 0 0-2.94 21.39c2.8 12.23 6.33 68.69 6.33 68.69l5.15 13.68-.15 16a15.34 15.34 0 0 1-3.16 7.1c-3.32 3.6-3.1 7.76-11 12.67s-13 6.76-13 13.31a17.27 17.27 0 0 1-.24 2.7c-.74 4.79-2.17 7.37 12.5 8.77 17.22 1.63 28.7-9.61 28.7-9.61s2.53-4.59 14.46-6.44c0 0 4.07-.22 4.3-3.83.08-1.24.06-3.62-.05-6.24-.19-5-.67-10.82-1.3-11.11-.79-.35-2.19-5.38-2.67-7.2h3.32s3.09-23.14 0-38.14-.29-25.61-.29-25.61l-.59-39.58s-4.17-4.23-.9-11.93 0-45.84 0-45.84 1.19-13.68 4.57-16.88.17-20.05 0-20.93l6 20.2s2.65 40.17 8.25 47.45l1.62 18.18s11.48 16.74 9.27 25.77 2.36 41.62 2.36 41.62v33.33s-5.16 13.39 2.06 18.19l3.11-.12c-1.06 1-1.82 2.39-3 3.62-1.38 1.42-2.16 6.82-2.6 11.46-.37 3.93-.49 7.31-.49 7.31s3.09 4.91 8.83 5.24 24.73 14.85 24.73 14.85 18.78 0 23.63-1l.29-.07a6.41 6.41 0 0 0 3.66-3 7.64 7.64 0 0 0 .89-5.5c-.61-2.87-2.88-6-7.93-8.69-12.59-6.65-14.46-12.87-14.46-12.87l-8.25-12.36h1.18s-.73-13.1 8.24-27.8l-.58-64.76s3.67-22.27-2.65-34.35c0 0-.52-12.81 3.71-16.74s-5.63-43.66-5.63-43.66-2-21.32-4.44-40.78c9.93 9.42 20.24-24.51 22-30.54h.26s-.05-.16-.12-.44.12-.43.12-.43c0-.05-2.2-7.85-.59-6.26s5.6-4.36 5.6-4.36-.59-32.46 6.33-48.82-3.12-56.15-3.12-56.15zm-29.59 20.65l.05-.09c1 19.82-.2 62.11-.2 62.11s-1.36 5.42-2.82 11.8l-1.05-40.18-1-37.84zm-126.73-13.66s5 62.58 0 71.6c-1.43 2.57-2.62 7.14-3.61 12.37-1.65-4.34-5.15-14.53-3.9-19.93 1.62-7-3.24-25.33-3.24-25.76s-.44-10.19 3.09-17.69 1.18-10.7 1.18-10.7 2.95-12.22 6.48-9.89z"
        transform="translate(-88.27 -31.08)"
        fill="url(#d)"
      />
      <path
        d="M93.44 552.02c-4.35 19.16-21.69-9.82-25.64-16.77l-.8-1.44 1.88-8.81 9.94-4.05a27.45 27.45 0 0 1 4.44 2.9c5.47 4.24 13.54 13.33 10.18 28.17zM227.94 520.66l-.11.43c0 .13-.09.28-.14.47-1.7 6-11.81 39.66-21.57 30.31-10.68-10.26-5.49-33.82-5.49-33.82h.1l22.47-2.3 4.45 4.58z"
        fill="#efb7b9"
      />
      <path
        d="M214.94 686.37l.57 64.28c-8.8 14.6-8.09 27.6-8.09 27.6l-29 1.15c-7.08-4.76-2-18.05-2-18.05v-33.09s-4.53-32.34-2.37-41.34-9.1-25.57-9.1-25.57l-1.58-18.05c-5.5-7.22-8.1-47.1-8.1-47.1l-5.91-20c.15.87 3.22 17.68 0 20.77s-4.48 16.76-4.48 16.76 3.18 37.85 0 45.5.86 12 .86 12l.59 39.29s-2.75 10.55.28 25.43 0 37.85 0 37.85h-31.2l.14-16-5.05-13.58s-3.47-56.05-6.21-68.18a30.44 30.44 0 0 1 2.88-21.24s-5.77-9.25-5.48-15.75-4.41-18.92-4.41-18.92l-6.72-45.65a88.55 88.55 0 0 0-3.32-26c-3.91-13-9.68-30.05-9.68-30.05l6.52.58 32.92 2.93s80-5.38 83.61-.91a14.93 14.93 0 0 1 1.52 4.66c3.59 16.15 8.34 66.71 8.34 66.71s9.68 39.44 5.52 43.34-3.64 16.61-3.64 16.61c6.2 11.92 2.59 34.02 2.59 34.02z"
        fill="#444053"
      />
      <path
        d="M147.29 798.14c-.23 3.58-4.23 3.8-4.23 3.8-11.7 1.84-14.18 6.4-14.18 6.4s-11.27 11.15-28.15 9.58c-14.39-1.38-13-4-12.26-8.7a17 17 0 0 0 .23-2.68c0-6.5 5-8.35 12.79-13.22s7.58-9 10.83-12.57 3.58-10.5 3.58-10.5c3.68-6.4 13 1 13 1 .43 2.27 14.3 2 14.3 2s1.84 7.37 2.78 7.8c.62.29 1.09 6.07 1.28 11 .09 2.5.1 4.87.03 6.09z"
        fill="#b07473"
      />
      <path
        d="M147.29 798.14c-.23 3.58-4.23 3.8-4.23 3.8-11.7 1.84-14.18 6.4-14.18 6.4s-11.27 11.15-28.15 9.58c-14.39-1.38-13-4-12.26-8.7 6.43 1.6 18.73 3.82 25.91-.08 10-5.42 17.13-9.21 17.13-9.21l15.73-8.01c.11 2.63.12 5 .05 6.22z"
        opacity=".1"
      />
      <path
        d="M235.47 817.43a6.28 6.28 0 0 1-3.6 3 1.43 1.43 0 0 1-.28.07c-4.77 1-23.19 1-23.19 1s-18.67-14.46-24.27-14.79-8.67-5.2-8.67-5.2.11-3.36.47-7.26c.44-4.61 1.21-10 2.56-11.38 2.5-2.6 3-6.17 8.67-3.9 0 0 8-14.11 17.44-3.21l9.76 14.81s1.84 6.17 14.2 12.78c4.95 2.65 7.18 5.77 7.77 8.62a7.63 7.63 0 0 1-.86 5.46z"
        fill="#b07473"
      />
      <path
        d="M235.47 817.43c-1.1.93-2.33 1.93-3.6 3a1.43 1.43 0 0 1-.28.07c-4.77 1-23.19 1-23.19 1s-18.67-14.46-24.27-14.79-8.67-5.2-8.67-5.2.11-3.36.47-7.26c5.73 1.72 14.43 4.75 16.76 8 3.57 5 14.42 11.91 14.42 11.91s20.23-1.94 29.22-2.21a7.63 7.63 0 0 1-.86 5.48z"
        opacity=".1"
      />
      <path
        d="M156.73 313.28l-26.66 28.17s-32.29-2.38-26.65-11.92c2.87-4.85 3.32-15 3.07-23.86-.24-8.53-1.12-15.79-1.12-15.79s45.29-22.54 41.82-1.52a34.87 34.87 0 0 0-.13 12c1.97 10.62 9.67 12.92 9.67 12.92z"
        fill="#efb7b9"
      />
      <path
        d="M147.18 288.36a34.87 34.87 0 0 0-.13 12 33.24 33.24 0 0 1-23.7 9.89c-6.16 0-12.75-5-17.7-7.95-.24-8.53-.29-12.42-.29-12.42s45.29-22.54 41.82-1.52z"
        opacity=".1"
      />
      <path
        d="M156.73 275.14a33.38 33.38 0 1 1-12.56-26.08 33.38 33.38 0 0 1 12.56 26.08z"
        fill="#efb7b9"
      />
      <path
        d="M202.12 525.61c-8.31 19.78-61.77 20.19-61.77 20.19v-21.56l-3.24-.21c1.4 6.17-2 21.23-2 21.23-42.25 6-52.54-18.09-52.54-18.09l1.46-8.24 32.92 2.93s80-5.38 83.61-.91a14.93 14.93 0 0 1 1.56 4.66z"
        opacity=".1"
      />
      <path
        d="M140.35 543.2v-21.57l-3.24-.2c1.4 6.17-2 21.23-2 21.23-31.79 4.48-45.5-8-50.33-14.5a19.65 19.65 0 0 1-2.21-3.6l12.89-72.59 3-106.83 4.65-18.74 1.08-9v-.1l.11.05 3.28 1.41 19.68 8.5 22.47-16.87.33-.25 1.11-.84 1.85 1.49 4.59 3.68 14.74 95.14s25.56 73.26 30.3 102.83c.19 1.18.35 2.28.47 3.31 3.11 26.95-62.77 27.45-62.77 27.45z"
        fill="#e1e7ef"
      />
      <circle cx="129.73" cy="329.32" r="1.9" fill="#67647e" />
      <circle cx="130.61" cy="346.65" r="1.9" fill="#67647e" />
      <circle cx="132.5" cy="374.72" r="1.9" fill="#67647e" />
      <circle cx="135.65" cy="404.94" r="1.9" fill="#67647e" />
      <circle cx="137.54" cy="433.33" r="1.9" fill="#67647e" />
      <circle cx="139.44" cy="463.56" r="1.9" fill="#67647e" />
      <circle cx="138.68" cy="493.47" r="1.9" fill="#67647e" />
      <path
        d="M105.53 462.53s-2.12 27.8-6 35.88-5.64 30.77-5.64 30.77l-9-1a19.65 19.65 0 0 1-2.21-3.6l12.89-72.59 3-106.83 4.65-18.74 1.08-9a.26.26 0 0 1 .12-.05 3.65 3.65 0 0 1 3.22.05l.44.22c-.13.37-.26.75-.38 1.14-3.52 11.05-4.84 31.43-4.84 31.43s5.06 37.27 5.63 54.61-2.96 57.71-2.96 57.71z"
        opacity=".1"
      />
      <path
        d="M83.26 523.85a6 6 0 0 1-.34.67c-3.51 5.93-12.41 9.7-15.12 10.73l-.8-1.44 1.88-8.81 9.94-4.05a27.45 27.45 0 0 1 4.44 2.9z"
        opacity=".1"
      />
      <path
        d="M59.2 381.98l-8.23 4.94-7.52 33.37s-9.39 28.32-2.16 48.54 11.44 31.75 11.44 31.75 2.89 23 7.22 24.85 6.22 2.89 6.22 2.89l.86 5.49s11.76-4 15.92-11-3.06-24.51-3.06-24.51-6.21-14.88-4.62-21.81-3.18-25.14-3.18-25.57-.43-10.12 3-17.56 1.16-10.61 1.16-10.61l-2.17-21.24z"
        fill="#67647e"
      />
      <path
        d="M202.8 519.36s-21.81 8.24-28.75 1-6.21-41-6.21-41-6.64-62.41-10.84-72.66-2-84.23-2-84.23-2.84-9.55-5.27-12.08a2.47 2.47 0 0 0-.52-.43l.85.18 3 .65 4.59 3.68 14.74 95.14s25.56 73.26 30.3 102.83z"
        opacity=".1"
      />
      <path
        d="M227.94 521.53h-.25c-2.74.35-27 3.28-27.09-1.76a15.56 15.56 0 0 1 .1-1.75l22.47-2.3 4.45 4.58c.08.3.15.56.21.76z"
        opacity=".1"
      />
      <path
        d="M204.73 348.55l15.95 8.31s13.23 34.36 15.4 49.1c0 0 9.82 39.47 3 55.7s-6.21 48.46-6.21 48.46-3.9 5.92-5.49 4.33.58 6.21.58 6.21-27.23 3.62-27.36-1.74 6.25-30.92 6.25-30.92 1.73-60.82-.73-70.35-1.39-69.1-1.39-69.1z"
        fill="#67647e"
      />
      <path
        d="M157.15 413.33s-9 21.95-11.85 23.4.58 7.22.58 7.22 16.33-22.82 11.27-30.62zM151.81 336.32c.1-.42-10.7 10.59-13.58 12.23s10.5-.09 13.58-12.23zM121.73 411.59s-16.47 10.66-14.31 14.86 14.31-14.86 14.31-14.86zM151.66 567.04s14 9 35.83 11.27zM118 588.71s13 16.32 18.93 16.76S118 588.71 118 588.71zM136.2 652.71c-.58.29-7.37 14.73-14.3 15.17s14.3-15.17 14.3-15.17zM196.45 684.34s12.88-2.88 15.74 6.36c0 0-.86-2.89-15.74-6.36zM187.78 737.22s15.6-3.18 18.92 1.16-18.92-1.16-18.92-1.16zM143.62 744.59c0 .14-15.89 3.18-15.26 5.2s16.94 1.73 17.52-1.45a3 3 0 0 0-2.26-3.75zM182.58 758.31s26.1-3.18 24.46 2.31-24.46-2.31-24.46-2.31zM45.91 436.73c.15.43 17.19 2.74 19.5 8.23 0 0-16.75-7.8-19.35-7.8M69.89 481.37s-14.16 4.48-13.16 11.27-1.43-3.17 13.16-11.27zM63.29 515.75s5.16-7.08 10.07-5.78-10.07 5.78-10.07 5.78zM144.16 249.06a8.26 8.26 0 0 1-1.66 1.24c-4.11 2.38-5.21 6-7.18 10.27-1.8 3.87-3.79 8-7.44 10.16-4.7 2.83-10.9 1.79-15.79 4.27a12.31 12.31 0 0 0-6.54 12.08 35.56 35.56 0 0 0 1.4 5.53 39.91 39.91 0 0 1 1.49 12 1.55 1.55 0 0 1 0 .37 33.38 33.38 0 1 1 35.76-55.93z"
        opacity=".1"
      />
      <path
        d="M143.29 239.02c-3.67-7.71-11.64-12.58-19.84-15-6.26-1.81-13.05-2.4-19.26-.41-3.54 1.13-6.77 3-10.08 4.72-6.19 3.13-13 5.6-17.65 10.74-1.08 1.19-2.08 2.73-1.76 4.31.24 1.18 1.16 2.08 1.75 3.13 1.33 2.34 1 5.29.09 7.84s-2.24 4.93-2.88 7.55-.39 5.69 1.55 7.56a35.12 35.12 0 0 0 2.92 2.08 15.73 15.73 0 0 1 2.77 3.15l5.51 7.53a76 76 0 0 1 6.9 10.62c1.38 2.73 2.44 5.65 4.27 8.09s4.7 4.4 7.74 4.13a1.47 1.47 0 0 0 1.22-.58 1.53 1.53 0 0 0 .16-.77 39.36 39.36 0 0 0-1.49-12 35.56 35.56 0 0 1-1.4-5.53 12.32 12.32 0 0 1 6.54-12.08c4.9-2.47 11.1-1.43 15.8-4.26 3.65-2.21 5.64-6.3 7.44-10.17 2-4.23 3.07-7.89 7.18-10.27s4.55-6.33 2.52-10.38z"
        fill="#585268"
      />
      <path
        d="M128.34 784.5s5.08 6.5 3.78 10.18-3.78-10.18-3.78-10.18zM197.41 800.75s1.13-8.72 5.68-8.8 4.77-.47 8.24.86 6.72 3.41 5.69 3.73-6-5-11-2.29a36.44 36.44 0 0 0-8.61 6.5zM113.11 338.15l14.24-10s-20.91-12.36-23.4-10.62-4.2 17.34-4.2 17.34z"
        opacity=".1"
      />
      <path
        d="M113.05 337.5l14.3-10.24s-20.91-12.35-23.4-10.62-4.2 18.21-4.2 18.21z"
        fill="#e1e7ef"
      />
      <path
        d="M113.05 337.5l14.3-10.24s-20.91-12.35-23.4-10.62-4.2 18.21-4.2 18.21z"
        opacity=".03"
      />
      <path
        d="M106.31 316.76l-.43-.22a3.69 3.69 0 0 0-4 .42L59 351.75s-9.32 12.89-8 35.14l25.28 35.83s2.89-12.14 6.36-9.83c0 0 4.91 62.12 0 71.08s-7.08 42.47-7.08 42.47l16.61 1.88s1.73-22.68 5.63-30.77 6-35.89 6-35.89 3.51-40.39 2.93-57.74-5.63-54.6-5.63-54.6 1.41-21.84 5.21-32.56z"
        fill="#67647e"
      />
      <path
        d="M149.02 331.81l-17.81-6.6s22.69-24.84 25.51-11.06z"
        opacity=".1"
      />
      <path
        d="M149.02 330.92l-17.81-6.59s22.69-24.85 25.51-11.07z"
        fill="#e1e7ef"
      />
      <path
        d="M149.02 330.92l-17.81-6.59s22.69-24.85 25.51-11.07z"
        opacity=".03"
      />
      <path d="M148.45 309.81a1 1 0 0 1 .73.15z" opacity=".1" />
      <path
        d="M150.18 308.07l47.28 10.2s13 2.89 22.39 35.53-12.86 72.65-12.86 72.65l-4.91-4.17 2.46 95.35s-21.82 8.23-28.75 1-6.22-41-6.22-41-6.64-62.43-10.84-72.71-2-84.23-2-84.23-3.91-13.19-6.55-12.62z"
        fill="#67647e"
      />
      <path
        d="M193.41 368.83c-.67.62-1.44 29.47 1.45 51.43a280.14 280.14 0 0 0 8.19 39.58l-4.29-88s-3.33-4.92-5.35-3.01zM187.63 343.98c1.16.72 6.22 12.71 3.9 17.63s-3.9-17.63-3.9-17.63zM143.01 239.02a26 26 0 0 0-10.39-10.88 24.67 24.67 0 0 1 7.79 9.15c2 4.05 1.44 8.11-2.53 10.41s-5.21 6-7.17 10.27c-1.8 3.87-3.8 8-7.45 10.16-4.7 2.84-10.89 1.8-15.79 4.26a12.33 12.33 0 0 0-6.54 12.09 34.47 34.47 0 0 0 1.4 5.53 39.27 39.27 0 0 1 1.48 12 1.54 1.54 0 0 1-.15.77 1.47 1.47 0 0 1-1.22.58 7 7 0 0 1-3.56-.66 8.29 8.29 0 0 0 6.16 2.39 1.47 1.47 0 0 0 1.22-.58 1.64 1.64 0 0 0 .16-.77 39.67 39.67 0 0 0-1.49-12 34.47 34.47 0 0 1-1.4-5.53 12.32 12.32 0 0 1 6.54-12.08c4.9-2.47 11.09-1.43 15.79-4.26 3.65-2.21 5.65-6.3 7.45-10.17 2-4.23 3.06-7.89 7.17-10.27s4.55-6.36 2.53-10.41z"
        opacity=".1"
      />
      <ellipse
        cx="968.23"
        cy="761.73"
        rx="41"
        ry="5.63"
        fill="#00c7fa"
        opacity=".1"
      />
      <ellipse
        cx="646.82"
        cy="814.56"
        rx="29.14"
        ry="4"
        fill="#00c7fa"
        opacity=".1"
      />
      <ellipse
        cx="386.08"
        cy="784.91"
        rx="29.14"
        ry="4"
        fill="#00c7fa"
        opacity=".1"
      />
      <path
        d="M402.13 775.81a11.64 11.64 0 0 0 3.83-5.79c.5-2.29-.48-5.05-2.68-5.89-2.46-.94-5.09.77-7.08 2.49s-4.28 3.69-6.88 3.32a10.5 10.5 0 0 0 3.24-9.81 4.21 4.21 0 0 0-.9-2c-1.37-1.46-3.85-.83-5.48.32-5.2 3.65-6.65 10.72-6.68 17.07-.52-2.29-.08-4.68-.1-7s-.65-5-2.64-6.22a8 8 0 0 0-4-1c-2.33-.09-4.94.15-6.53 1.86-2 2.12-1.47 5.68.25 8s4.35 3.81 6.77 5.42a15 15 0 0 1 4.83 4.61 4.16 4.16 0 0 1 .36.83h14.66a41.24 41.24 0 0 0 9.03-6.21zM984.86 754.71a11.71 11.71 0 0 0 3.87-5.79c.5-2.29-.48-5-2.68-5.89-2.46-.94-5.09.77-7.08 2.49s-4.28 3.69-6.89 3.32a10.45 10.45 0 0 0 3.24-9.81 4 4 0 0 0-.9-2c-1.36-1.46-3.84-.83-5.47.32-5.2 3.65-6.65 10.72-6.68 17.07-.53-2.29-.08-4.68-.1-7s-.66-5-2.64-6.22a8 8 0 0 0-4-1c-2.34-.09-4.94.15-6.54 1.86-2 2.12-1.47 5.68.26 8s4.35 3.81 6.77 5.42a15 15 0 0 1 4.83 4.61 4.83 4.83 0 0 1 .36.83h14.65a41.06 41.06 0 0 0 9-6.21zM654.73 801.46a11.73 11.73 0 0 0 3.84-5.79c.49-2.3-.49-5-2.68-5.89-2.46-.94-5.09.76-7.08 2.49s-4.28 3.68-6.89 3.32a10.47 10.47 0 0 0 3.24-9.81 4.11 4.11 0 0 0-.9-2c-1.37-1.46-3.84-.83-5.48.32-5.2 3.66-6.65 10.72-6.68 17.08-.52-2.29-.08-4.68-.09-7s-.66-5-2.64-6.22a8.07 8.07 0 0 0-4-1c-2.34-.08-4.94.15-6.54 1.86-2 2.13-1.47 5.69.26 8s4.35 3.8 6.76 5.42a15 15 0 0 1 4.88 4.68 5.08 5.08 0 0 1 .36.82h14.64a40.73 40.73 0 0 0 9-6.28z"
        fill="#00c7fa"
      />
      <path
        d="M1036.86 376.24c-13.12-.26-24.7-9.56-31.26-20.84a21 21 0 0 1-3.16-8.92 10.52 10.52 0 0 1 .36-2.14 21 21 0 0 0 1-3.26 5.46 5.46 0 0 0 0-1.34v-.06c.32-2.42-1.1-4.75-2.88-6.42s-3.95-2.88-5.78-4.49c-5.64-4.95-7.35-12.89-7.46-20.45v-.4c.06-3.23.32-6.48.29-9.72a40.57 40.57 0 0 0-.24-5.51c-.54-4.58-2.28-9.24-5.88-12.16-9.39-7.61-25.18.31-34.89-6.89-2.37-1.75-4.28-4.36-7.14-5-2.17-.52-4.42.18-6.53.88-7.16 2.36-15.14 5.47-17.94 12.43-1.6 4-1.15 8.49-2.62 12.51-1 2.69-2.77 5-4.09 7.56a11.83 11.83 0 0 0-1.53 6.31 7.26 7.26 0 0 0 .47 3.36 8.46 8.46 0 0 0 2.32 3.31 11 11 0 0 1-1.4 2.22c-1.83 2.24-4.64 3.84-6.54 6-3.52 4.08-3.39 9.63-1.65 14.43s4.86 9.17 7 13.84c.93 2 1.68 4.3.71 6.32-.67 1.4-2.07 2.46-3.16 3.67a11.56 11.56 0 0 0-2.86 6.42c-21.43 4.89-21.44 22.1-21.44 22.1L869 419.14s-1.85 4.9-4 11.37l-13.7-2.45 9.46 15.94c-1.81 6.49-3.08 12.51-2.66 15.53 0 0-4.25 20 3.31 23.49l16.7 7.51a9.21 9.21 0 0 0 2.31 1l.68.3a1.77 1.77 0 0 0 1.56 0h.27a2.12 2.12 0 0 0 1-.14 1.8 1.8 0 0 0 .83-.91.36.36 0 0 0 0-.09l5-1.45 4.24 5c1.91 1.34 3.78 2.51 5.61 3.56l-6.52 65.2s-1.06 86.66-4.25 106.39c-1.19 7.31-1.2 12.29-.75 15.68l-.12.22c.79 5.57 2.84 6.67 2.84 6.67v-.08l.12.08a56.55 56.55 0 0 1 3.43-7.35v1.42c-.06 7.36-.29 17.65-1 24.34-1.3 11.38 3.31 49.08 3.31 49.08l1.59 34.3a31.72 31.72 0 0 1-3.9 16.7c-3.77 6.85-8.68 16.48-9 20.75a5.57 5.57 0 0 0 0 .7l-8.36 9.73s-3.2 4.93 4 6.92c3.87 1.08 10.56 0 15.92-1.27a10.64 10.64 0 0 0 8.26-10.35A36.61 36.61 0 0 1 912 824l1.35 7.89 9 2.23 1.15-21.63a9.47 9.47 0 0 0 .62-3.82c1.77-15.38-4.17-14-4.17-14a1 1 0 0 1 .29.54c-.1-.17-.2-.35-.29-.53-3.65-7.2-1.86-19-1.86-19s4.73-34.28 6.39-43.33c1.17-6.39.69-27.33.3-39.06 0-.49 0-1-.05-1.41 13.93-.18 31-.66 43-1.82v1.42l-2.22 81a44.53 44.53 0 0 1-3.09 15.06c0 .09-.08.18-.11.27a65.71 65.71 0 0 0-4.48 21.19l-1 25.74v.71c-1.79.69-4.61 2.68-4.69 8.45-.12 8.45 14.77 5.63 14.77 5.63 14.89 0 15-15.5 15-15.5s.48-14.21 1.18-23.72-2.24-7.41-2.24-7.41l-.22 27v.21-23.71l.23-3.44v-.1l.05-.73 1.85-27.9s13.71-46.5 15.84-55.42c1.51-6.33.88-25.43.38-36 0-.49 0-.95-.06-1.4 4.24-.38 8-.42 9.51-.42h.69s-.71-74.68-2.48-102.86-4.61-53.9-11.71-61.65c-4.28-4.68-10.25-19.14-14.31-29.85a150.17 150.17 0 0 0 26.25 8.6c22.46 4.7 19.39-14.8 19.39-14.8l-2.28-36.87h.15a187.27 187.27 0 0 0-2.48-28.83c-1.18-7.31-3-14.87-5.78-21 2.44-.93 4.84-2 7.2-3 6.1-2.69 13-6.51 13.86-13.09h-.3a9.16 9.16 0 0 0 .23-1.4zm-139.22 53.34c.06 3.81-.09 10.41-.31 17.72l-7.13-9.52 7.15-11.6zm95.56 19.31zm3 14.4l-11.88-3.82a53.63 53.63 0 0 1 7.34-9.08l1-1-.37.08.58-.52.34-.08-.55.52.65-.13a20.31 20.31 0 0 0 4.05 8.14c4.24 4.72-1.2 5.89-1.2 5.89z"
        transform="translate(-88.27 -31.08)"
        fill="url(#e)"
      />
      <path
        fill="#a27772"
        d="M835.72 774.95l-1.4 26.34-8.86-2.21-1.87-10.96 12.13-13.17z"
      />
      <path
        opacity=".1"
        d="M835.72 774.95l-1.4 26.34-8.86-2.21-1.87-10.96 12.13-13.17z"
      />
      <path
        d="M868.24 804.79l13.52 2.8 10-8.86v-24.95l.22-3.41v-.1l.05-.72 1.82-27.7s13.52-46.17 15.62-55c1.49-6.29.87-25.26.38-35.74-.2-4.3-.38-7.17-.38-7.17l-29.84-7.23-.63 23-2.18 80.4a44.36 44.36 0 0 1-3.06 14.95l-.1.27a65.28 65.28 0 0 0-4.33 21.07l-1 25.55v.71z"
        fill="#cc818c"
      />
      <path
        d="M892.02 769.56v.71l.05-.72zM868.24 804.79l13.52 2.8 10-8.86v-2.12a2.84 2.84 0 0 1-1.44 2.29l-.14.08a26.89 26.89 0 0 1-15.18 3l-5.28-.45a5.53 5.53 0 0 0-1.39.34v.71z"
        opacity=".1"
      />
      <path
        d="M890.21 799.68l.14-.08a2.83 2.83 0 0 0 1.45-2.48l.22-26.86s2.92-2.07 2.22 7.37-1.17 23.55-1.17 23.55-.11 15.39-14.8 15.39c0 0-14.69 2.79-14.58-5.6s6.07-8.74 6.07-8.74l5.27.46a27 27 0 0 0 15.18-3.01z"
        fill="#b07473"
      />
      <path
        d="M797.83 799.08c.35 6.06 18.18 2.56 18.18 2.56l12-23.31s10-7.7 5-14.46a10.28 10.28 0 0 1-.74-1.15v-.06c-.11-.18-.2-.36-.3-.55-3.6-7.14-1.83-18.85-1.83-18.85s4.66-34 6.3-43c1.15-6.35.68-27.14.29-38.78-.15-4.83-.29-8.09-.29-8.09l-29.62-7.92v8.83c-.06 7.3-.28 17.52-1 24.16-1.28 11.31 3.27 48.73 3.27 48.73l1.57 34.06a31.6 31.6 0 0 1-3.93 16.53c-3.72 6.8-8.56 16.37-8.9 20.61a4 4 0 0 0 0 .69z"
        fill="#cc818c"
      />
      <path
        d="M797.83 799.08c.35 6.06 18.18 2.56 18.18 2.56l12-23.31s10-7.7 5-14.46a10.28 10.28 0 0 1-.74-1.15c-.16 3.53-4 12.34-4 12.34s-9.91 19.83-13 24.37-16.85-.84-17.36-1a4 4 0 0 0-.08.65z"
        opacity=".1"
      />
      <path
        d="M831.95 762.09s5.86-1.36 4.12 13.91a9.85 9.85 0 0 1-4.65 8.73c-4.19 2.64-10.67 8.31-13.94 19.34a10.56 10.56 0 0 1-8.14 10.29c-5.29 1.23-11.89 2.32-15.71 1.25-7.11-2-4-6.87-4-6.87l8.16-9.68s14.22 5.6 17.37 1.05 13-24.37 13-24.37 5.57-12.37 3.79-13.65z"
        fill="#b07473"
      />
      <path
        d="M879.67 639.48l-.63 23c8-.77 13.64-1.85 14.62-3.36 2.09-3.25 9.73-4.63 16.23-5.19-.2-4.3-.38-7.17-.38-7.17zM806.79 657.06a11.07 11.07 0 0 1 3.27-3.94c3.15-1.75 2.81 11.19 2.81 11.19s10.45.1 23.84-.07c-.15-4.84-.29-8.09-.29-8.09l-29.62-7.92s.04 3.69-.01 8.83z"
        opacity=".1"
      />
      <path
        d="M803.42 660.14s3.5-9.47 6.64-11.21 2.81 11.19 2.81 11.19 76.94.7 80.79-5.25 26.23-5.59 26.23-5.59-.7-74.15-2.45-102.13-4.55-53.51-11.54-61.2c-4.53-5-11-21.09-14.94-31.83-2.17-5.87-3.6-10.14-3.6-10.14l-73.44 4.2-.6 5.94-7.8 78s-1 86-4.2 105.62 2.1 22.4 2.1 22.4z"
        fill="#444053"
      />
      <g opacity=".1">
        <path d="M887.73 654.92c3.84-5.94 26.23-5.59 26.23-5.59s-.7-74.15-2.45-102.13-4.55-53.51-11.54-61.2c-4.53-5-11-21.09-14.94-31.83-1.82-4.93-3.12-8.73-3.49-9.82l5.7-.32s1.43 4.27 3.6 10.14c4 10.74 10.41 26.85 14.94 31.83 7 7.69 9.79 33.22 11.54 61.2s2.41 102.08 2.41 102.08-22.38-.36-26.22 5.64c-3.29 5.08-59.91 5.31-76.35 5.27 21.08-.1 67.57-.73 70.57-5.27zM804.1 648.92c1.42-.79 2.13 1.4 2.48 4a56.63 56.63 0 0 0-3.31 7.16s-2-1.09-2.8-6.62c1.11-1.97 2.4-3.85 3.63-4.54z" />
      </g>
      <path
        d="M826.11 264.58c-5.08 6.94.06 16.79-5.39 23.53-1.8 2.23-4.57 3.82-6.45 6-3.48 4.06-3.34 9.56-1.63 14.33s4.8 9.1 6.92 13.74c.92 2 1.66 4.27.71 6.27-.66 1.39-2 2.44-3.12 3.65-3.5 3.91-3.6 9.35-1.72 13.95s5.49 8.59 9 12.47c1.4 1.54 3.17 3.23 5.5 3.19a7.75 7.75 0 0 0 3.46-1.14 36.44 36.44 0 0 0 17.57-20.65 36.83 36.83 0 0 0-1.5-25.35c-3-7.07-7.88-13.85-7.92-21.33 0-5.93 3.05-11.59 3.59-17.5.66-7.17-3.59-18.57-12.25-21.7.57 4.63-4.15 7.02-6.77 10.54z"
        fill="#585268"
      />
      <path
        d="M826.11 264.58c-5.08 6.94.06 16.79-5.39 23.53-1.8 2.23-4.57 3.82-6.45 6-3.48 4.06-3.34 9.56-1.63 14.33s4.8 9.1 6.92 13.74c.92 2 1.66 4.27.71 6.27-.66 1.39-2 2.44-3.12 3.65-3.5 3.91-3.6 9.35-1.72 13.95s5.49 8.59 9 12.47c1.4 1.54 3.17 3.23 5.5 3.19a7.75 7.75 0 0 0 3.46-1.14 36.44 36.44 0 0 0 17.57-20.65 36.83 36.83 0 0 0-1.5-25.35c-3-7.07-7.88-13.85-7.92-21.33 0-5.93 3.05-11.59 3.59-17.5.66-7.17-3.59-18.57-12.25-21.7.57 4.63-4.15 7.02-6.77 10.54zM882.5 516.7c-10.18.54-19.76 4.91-28.67 9.86s-17.53 10.6-27.12 14.08M876.17 540.68a42.09 42.09 0 0 0-26.44 12.85c-2.47 2.62-4.6 5.56-7.18 8.07a32 32 0 0 1-14.17 8M878.26 558.92a46.21 46.21 0 0 0-21.25 12.81c-1.56 1.68-3 3.49-4.54 5.16-8.43 9-20.33 13.85-31.82 18.39"
        opacity=".1"
      />
      <path
        d="M877.39 305.83a209.63 209.63 0 0 0 2.1 24.3c.94 5.74 2.28 10.85 4.2 13.12 5.59 6.65-27.28 15.57-27.28 15.57l-19.41-15s15.39-14.17 8.22-28 32.17-9.99 32.17-9.99z"
        fill="#cc818c"
      />
      <path
        d="M813.32 454.12h77.64c-2.17-5.87-3.6-10.14-3.6-10.14l-73.44 4.2z"
        opacity=".1"
      />
      <path
        d="M808.32 452.72h83c-2.33-8.34 0-16.07 3.33-22a48.59 48.59 0 0 1 8.69-11.28l.57-.51 29-6.43 1.56-.34s.23-52.69-18.42-59.92-29.85-17-29.85-17l-25.64 7.92-18.89-9.55c-6.06 6.53-22.15 4-22.15 4-26.35 3-26.35 22.85-26.35 22.85s15.39 35.91 16.56 35.91-1.41 56.35-1.41 56.35z"
        fill="#67647e"
      />
      <path
        d="M836.98 419.22s-16.93-3.75-22.69-10.31M922.33 399.56l-19.6 16.09a32.59 32.59 0 0 0 .65 3.78l.57-.51 29-6.43zM869.17 447.13s4.3 2.42 10.88 5.59h11.28c-2.33-8.34 0-16.07 3.33-22l-19.93-6.45c6.8 6.3-5.56 22.86-5.56 22.86z"
        opacity=".1"
      />
      <path
        d="M804.82 354.1l-11.66 6.29-11.43 28.91s-11.89 31.71-10.73 40.11c0 0-4.19 19.81 3.27 23.31l19.46 8.8a1.8 1.8 0 0 0 2.33-2.49c-2.77-5.25-5.81-13.45-1-18l-5.6-11.65 20.27-33.08 6.75-11.38z"
        fill="#67647e"
      />
      <path
        d="M830.73 412.6c1 4.12 4.42 10.45 15.7 12.84l12.42 10.14 13.17 6 5.36 2.43 2.28-16.44-5.17-2.83-6-3.29s-13.59-24.64-35.12-14.23a4.77 4.77 0 0 0-2.64 5.38z"
        opacity=".1"
      />
      <path
        d="M831.44 411.2c1 4.12 4.42 10.45 15.7 12.84l12.42 10.15 13.17 6 5.36 2.43 2.28-16.44-5.17-2.82-6-3.3s-13.59-24.63-35.12-14.23a4.77 4.77 0 0 0-2.64 5.37z"
        fill="#cc818c"
      />
      <circle cx="855.7" cy="297.09" r="30.08" opacity=".1" />
      <circle cx="855.7" cy="296.39" r="30.08" fill="#cc818c" />
      <path
        d="M874.33 360.65l-9-17.58s13.24-5.34 14.2-11.54 12.68 7.26 10.14 11.72-15.34 17.4-15.34 17.4z"
        opacity=".1"
      />
      <path
        d="M874.33 359.25l-9-17.58s13.24-5.34 14.2-11.54 12.68 7.27 10.14 11.72-15.34 17.4-15.34 17.4z"
        fill="#67647e"
      />
      <path
        d="M800.32 404.65l50 67.19s-18.42 10-43.84-7.93l-11-13.05-31.25-52.7z"
        fill="#f6f8fb"
      />
      <path
        d="M790.48 441.18l4.55-.12s27.8-27 34.62-13.34-17.31 26.4-17.31 26.4l-7.34 4-9.62 2.8-6.12-8.22z"
        fill="#cc818c"
      />
      <path
        d="M797.19 455.76c.42 1.55.82 3.26.12 4.7a1.78 1.78 0 0 1-.83.9 2 2 0 0 1-1 .14 9.55 9.55 0 0 1-6.27-3.11 28.28 28.28 0 0 1-4.07-5.88c-1.24-2.15-2.53-4.55-2.08-7 .49-2.68 2.88-4.54 5.16-6 4.61-3.05 4.72.5 5.77 4.42z"
        opacity=".1"
      />
      <path
        d="M796.49 455.76c.42 1.55.82 3.26.12 4.7a1.78 1.78 0 0 1-.83.9 2 2 0 0 1-1 .14 9.55 9.55 0 0 1-6.27-3.11 28.28 28.28 0 0 1-4.07-5.88c-1.24-2.15-2.53-4.55-2.08-7 .49-2.68 2.88-4.54 5.16-6 4.61-3.05 4.72.5 5.77 4.42z"
        fill="#67647e"
      />
      <path
        opacity=".1"
        d="M809.72 396.3l2.33-3.93-2.04 7.3-.29-3.37zM872.73 440.15l5.36 2.43 2.28-16.44-5.17-2.82c3.53 4.06.44 11.6-2.47 16.83zM894.24 421.07s-17.31 1.05-24.65-3.67"
      />

      <g opacity=".1">
        <path d="M892.09 432.11a48.83 48.83 0 0 1 8.7-11.28 24 24 0 0 1 2.56-1.4l27-5.54 1.56-.34s.24-52.69-18.42-59.92a112.66 112.66 0 0 1-29.09-16.39l2.05-.63s11.19 9.79 29.84 17 18.44 59.94 18.44 59.94h-2.8l-27.64 5.29-1.56 1.49A53.33 53.33 0 0 0 893.9 432a29.29 29.29 0 0 0-2.31 22.12h-2.86c-2.3-8.34.07-16.07 3.36-22.01zM818.4 339.12c.45-.06.88-.13 1.34-.18a49.24 49.24 0 0 0 5.71.47 51.47 51.47 0 0 1-7.05-.29zM857.98 344.53l-17.08-8.61a9.55 9.55 0 0 0 1-.91l17.82 9z" />
      </g>
      <path
        d="M923.03 398.16l11.43 14 2.33 38s3 19.35-19.12 14.69-47.8-19.12-47.8-19.12 12.36-16.56 5.6-22.85l31.71 10.26s5.36-1.17 1.16-5.83-4.94-13.06-4.94-13.06z"
        fill="#67647e"
      />

      <path
        d="M928.16 438.27l6.3 7.22a9.07 9.07 0 0 1-6.3-7.22zM917.44 437.1l9.79 12.59-4.89 1.17-4.9-13.76zM819.79 282.58c-1.08-2.63-.26-5.67 1-8.2s3.07-4.83 4-7.51c1.45-4 1-8.48 2.58-12.42 2.77-6.9 10.64-10 17.7-12.33 2.08-.69 4.3-1.39 6.44-.88 2.82.68 4.71 3.27 7 5 9.58 7.14 25.15-.72 34.41 6.84 3.55 2.89 5.27 7.53 5.8 12.07s0 9.15-.05 13.73c-.15 8 1.34 16.78 7.35 22.09 1.81 1.6 3.94 2.81 5.7 4.46s3.15 4 2.84 6.37a21.7 21.7 0 0 1-1 3.23c-1.2 4.18.58 8.61 2.75 12.38 6.48 11.2 17.89 20.43 30.84 20.69-.87 6.53-7.65 10.32-13.67 13-7.67 3.41-15.73 6.76-24.11 6.33s-17.12-5.79-18.61-14c-.51-2.83-.44-6.3-2.9-7.79-1.48-.9-3.4-.67-5-1.35-2.31-1-3.46-3.54-4.22-5.94a53.59 53.59 0 0 1-2.49-15.24c-.1-6.13.72-12.82-2.76-17.87-3.22-4.67-8.94-7-12.65-11.34-3.42-4-7.15-8.78-12.76-9.54-7.54-1.09-23.6 9.46-28.19-1.78z"
        opacity=".1"
      />

      <path
        d="M819.79 281.18c-1.08-2.63-.26-5.67 1-8.2s3.07-4.83 4-7.51c1.45-4 1-8.48 2.58-12.42 2.77-6.9 10.64-10 17.7-12.33 2.08-.69 4.3-1.39 6.44-.88 2.82.68 4.71 3.27 7 5 9.58 7.15 25.15-.72 34.41 6.84 3.55 2.9 5.27 7.53 5.8 12.07s0 9.15-.05 13.73c-.15 8 1.34 16.78 7.35 22.09 1.81 1.6 3.94 2.81 5.7 4.46s3.15 4 2.84 6.37a22.18 22.18 0 0 1-1 3.24c-1.2 4.17.58 8.61 2.75 12.37 6.48 11.2 17.89 20.43 30.84 20.69-.87 6.53-7.65 10.32-13.67 13-7.67 3.42-15.73 6.76-24.11 6.33s-17.12-5.79-18.61-14.05c-.51-2.83-.44-6.3-2.9-7.79-1.48-.9-3.4-.67-5-1.35-2.31-1-3.46-3.54-4.22-5.94a53.59 53.59 0 0 1-2.49-15.24c-.1-6.13.72-12.82-2.76-17.87-3.22-4.67-8.94-7-12.65-11.34-3.42-4-7.15-8.78-12.76-9.54-7.54-.99-23.6 9.51-28.19-1.73z"
        fill="#585268"
      />

      <path
        d="M841.11 358.47l17.24-14s-11.8-6.4-13.21-11.86-10.85 2.59-9.89 7.49 5.86 18.37 5.86 18.37z"
        opacity=".1"
      />

      <path
        d="M841.81 356.37l17.24-14s-11.8-6.4-13.21-11.86-10.85 2.59-9.89 7.49 5.86 18.37 5.86 18.37z"
        fill="#67647e"
      />

      <circle cx="859.72" cy="354.09" r="1.37" opacity=".1" />

      <circle cx="859.72" cy="361.71" r="1.37" opacity=".1" />

      <circle cx="859.72" cy="369.32" r="1.37" opacity=".1" />

      <g opacity=".1">
        <path d="M826.73 261.75c1.36-3.75 1.07-7.95 2.34-11.72a13.56 13.56 0 0 0-1.45 2.68c-1.58 3.94-1.14 8.44-2.58 12.43 0 .07-.07.15-.1.23a22.14 22.14 0 0 0 1.79-3.62zM935.52 355.98c-7.67 3.42-15.73 6.76-24.12 6.33s-17.11-5.79-18.6-14.05c-.51-2.83-.44-6.3-2.9-7.79-1.48-.9-3.4-.67-5-1.35-2.32-1-3.46-3.54-4.22-5.94a53.59 53.59 0 0 1-2.49-15.26c-.1-6.13.71-12.82-2.76-17.87-3.22-4.67-8.94-7-12.65-11.34-3.43-4-7.15-8.78-12.77-9.54-7.7-1-23.77 9.5-28.35-1.74a8.83 8.83 0 0 1 .29-6.5c-.33.56-.65 1.12-.94 1.69-1.3 2.53-2.12 5.57-1 8.2 4.59 11.24 20.65.69 28.36 1.74 5.61.76 9.34 5.57 12.77 9.54 3.71 4.3 9.42 6.67 12.64 11.35 3.48 5 2.67 11.74 2.77 17.86a53.35 53.35 0 0 0 2.48 15.25c.76 2.39 1.91 5 4.22 5.94 1.6.67 3.52.45 5 1.35 2.45 1.48 2.39 5 2.89 7.78 1.49 8.26 10.23 13.63 18.61 14.06s16.45-2.92 24.11-6.34c5.52-2.45 11.67-5.86 13.32-11.44-2.68 3.67-7.36 6.16-11.66 8.07z" />
      </g>
    </svg>
  );
}

export default IllustrationGrowTogether;
